var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fill-height":""}},[_c('v-row',[_c('v-col',{staticClass:"text-center"},[_c('v-slide-y-transition',[_c('v-progress-circular',{attrs:{"size":150,"width":6,"color":"primary","indeterminate":""}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }